module.exports = __webpack_public_path__ + "static/media/comment-logo.9a8bc438.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/comment-logo.svg
// module id = 230
// module chunks = 0